import React from 'react';
import { PhoneCall, ClipboardList, Network, CheckCircle2 } from 'lucide-react';

const steps = [
  { icon: PhoneCall, title: 'One call, one point of contact' },
  { icon: ClipboardList, title: 'Scoped, discreet engagement' },
  { icon: Network, title: 'The right people, quietly convened' },
  { icon: CheckCircle2, title: 'Move the matter forward' },
];

export default function HowItWorks() {
  return (
    <section id="how" className="px-4 md:px-6 pt-6 md:pt-8">
      <div className="relative max-w-7xl mx-auto rounded-[32px] md:rounded-[40px] overflow-hidden border bg-[#EFE9DC] border-[#E7DFCF]">
        <div className="absolute -top-24 -left-20 h-72 w-72 rounded-full blur-3xl opacity-70 pointer-events-none bg-white" />
        <div className="absolute -bottom-32 -right-16 h-96 w-96 rounded-full blur-3xl opacity-70 pointer-events-none bg-white" />

        <div className="relative px-6 md:px-12 py-20 md:py-28">
          <div className="text-center reveal">
            <span className="inline-block text-[11px] font-semibold tracking-[0.2em] uppercase bg-white border border-neutral-200 px-3 py-1.5 rounded-full text-neutral-800">
              How it works
            </span>
            <h2 className="font-display-bold mt-6 text-4xl md:text-[64px] leading-[1.05] text-neutral-900 max-w-4xl mx-auto">
              A single relationship,
              <br />
              for the matters that matter.
            </h2>
          </div>

          <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={s.title} className="card-hover reveal bg-white rounded-[24px] p-7 md:p-9 border border-neutral-200" style={{ transitionDelay: `${i * 80}ms` }}>
                  <div className="h-16 w-16 rounded-2xl flex items-center justify-center bg-neutral-900">
                    <Icon className="h-8 w-8 text-white" strokeWidth={1.75} />
                  </div>
                  <h3 className="font-display-bold mt-7 text-[20px] leading-snug text-neutral-900">{s.title}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
